import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { ClariChatComponent } from './clari-chat/clari-chat.component';
import { DoubleChatComponent } from './double-chat/double-chat.component';
import { MistralLargeComponent } from './dialogs/mistral-large/mistral-large.component';
import { FourOMiniComponent } from './dialogs/four-o-mini/four-o-mini.component';
import { OThreeComponent } from './dialogs/o-three/o-three.component';
import { OpusFourComponent } from './dialogs/opus-four/opus-four.component';
import { SonnetFourComponent } from './dialogs/sonnet-four/sonnet-four.component';
import { DeepseekComponent } from './dialogs/deepseek/deepseek.component';
import { CohereRPlusComponent } from './dialogs/cohere-r-plus/cohere-r-plus.component';
import { GptFourOneComponent } from './dialogs/gpt-four-one/gpt-four-one.component';
import { LlamaThreePointThreeComponent } from './dialogs/llama-three-point-three/llama-three-point-three.component';
import { SonnetThreeSevenComponent } from './dialogs/sonnet-three-seven/sonnet-three-seven.component';
import { ModelSelectionDialogComponent } from './dialogs/model-selection-dialog/model-selection-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MaverickComponent } from './dialogs/maverick/maverick.component';
import { JambaComponent } from './dialogs/jamba/jamba.component';
import { PixtralImageComponent } from './dialogs/pixtral-image/pixtral-image.component';
import { GeminiProComponent } from './dialogs/gemini-pro/gemini-pro.component';
import { ScoutComponent } from './dialogs/scout/scout.component';
import { GptFiveComponent } from './dialogs/gpt-five/gpt-five.component';
import { ClariMediaComponent } from './clari-media/clari-media.component';
import { StabilityComponent } from './dialogs/stability/stability.component';
import { DalEComponent } from './dialogs/dal-e/dal-e.component';
import { AiCatalogComponent } from './dialogs/ai-catalog/ai-catalog.component';
import { TheVoiceComponent } from './dialogs/the-voice/the-voice.component';
import { ClariCoachDialogComponent } from './dialogs/clari-coach-dialog/clari-coach-dialog.component';


import { TennisCoachComponent } from './tennis-coach/tennis-coach.component';
import { TourOverlayComponent } from './tour-overlay/tour-overlay.component';

import { ResumeDialogViewComponent } from './dialogs/resume-dialog-view/resume-dialog-view.component';
import { ResumeHeroComponent } from './resume-hero/resume-hero.component';
import { ClariVideoChatComponent } from './clari-video-chat/clari-video-chat.component';
import { PalmyraComponent } from './dialogs/palmyra/palmyra.component';
import { NovaLiteComponent } from './dialogs/nova-lite/nova-lite.component';

import { ModelSwitchOverlayComponent } from '../components/model-switch-overlay/model-switch-overlay.component';
import { NovaProComponent } from './dialogs/nova-pro/nova-pro.component';
import { GlmComponent } from './dialogs/glm/glm.component';
import { Deepseekv3Component } from './dialogs/deepseekv3/deepseekv3.component';
import { DynamicCodeComponent } from './dynamic-code/dynamic-code.component';

import { GoogleImageComponent } from './dialogs/google-image/google-image.component';
import { CogxComponent } from './dialogs/cogx/cogx.component';
import { Googleveo31Component } from './dialogs/googleveo31/googleveo31.component';
import { ModelGardenComponent } from './model-garden/model-garden.component';
import { OpusSixComponent } from './dialogs/opus-six/opus-six.component';
import { GptFiveMiniComponent } from './dialogs/gpt-five-mini/gpt-five-mini.component';
import { CoherecommandrComponent } from './dialogs/coherecommandr/coherecommandr.component';
import { Llama31Component } from './dialogs/llama31/llama31.component';
import { ClariImageChatComponent } from './clari-image-chat/clari-image-chat.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EcommerceDashboardComponent } from './ecommerce-dashboard/ecommerce-dashboard.component';
import { EcommerceDashboardResolver } from './ecommerce-dashboard/ecommerce-dashboard.resolver';
import { EcommerceDashboardService } from './ecommerce-dashboard/ecommerce-dashboard.service';
import { HaikuComponent } from './dialogs/haiku/haiku.component';
import { ModelBioDetailDialogComponent } from './dialogs/model-bio-detail-dialog/model-bio-detail-dialog.component';


export const authenticationRoutes: Routes = [
  { path: '', redirectTo: 'clarity', pathMatch: 'full' },
  { path: 'clarity', component: ClariChatComponent, data: { showModelName: true } },
  { path: 'clarichat', component: ClariChatComponent, data: { showModelName: true } },
  { path: 'coach', component: TennisCoachComponent },
  { path: 'code', component: DynamicCodeComponent },
  { path: 'clari-media', component: ClariMediaComponent },
  { path: 'doublechat', component: DoubleChatComponent, data: { showModelName2: true } },
  { path: 'videos', component: ClariVideoChatComponent },
  { path: 'images', component: ClariImageChatComponent },
  { path: 'roster', component: ModelGardenComponent },
  { path: 'resume', component: ResumeHeroComponent },
  {
    path: 'ai-dashboard',
    component: EcommerceDashboardComponent,
    resolve: { data: EcommerceDashboardResolver }
  },
  {
    path: 'dashboard',
    component: EcommerceDashboardComponent,
    resolve: { data: EcommerceDashboardResolver }
  }

];

@NgModule({
  declarations: [
    ClariChatComponent,
    DoubleChatComponent,
    MistralLargeComponent,
    FourOMiniComponent,
    OThreeComponent,
    OpusFourComponent,
    SonnetFourComponent,
    DeepseekComponent,
    CohereRPlusComponent,
    GptFourOneComponent,
    LlamaThreePointThreeComponent,
    SonnetThreeSevenComponent,
    ModelSelectionDialogComponent,
    MaverickComponent,
    JambaComponent,
    PixtralImageComponent,
    GeminiProComponent,
    ScoutComponent,
    GptFiveComponent,
    ClariMediaComponent,
    StabilityComponent,
    DalEComponent,
    AiCatalogComponent,
    TheVoiceComponent,
    ModelGardenComponent,
    TennisCoachComponent,
    TourOverlayComponent,
    ResumeDialogViewComponent,
    ResumeHeroComponent,
    ClariVideoChatComponent,
    PalmyraComponent,
    NovaLiteComponent,
    ModelSwitchOverlayComponent,
    NovaProComponent,
    GlmComponent,
    Deepseekv3Component,
    DynamicCodeComponent,
    ClariCoachDialogComponent,
    GoogleImageComponent,
    CogxComponent,
    Googleveo31Component,
    OpusSixComponent,
    GptFiveMiniComponent,
    CoherecommandrComponent,
    Llama31Component,
    HaikuComponent,
    ClariImageChatComponent,
    DashboardComponent,
    EcommerceDashboardComponent,
    ModelBioDetailDialogComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    MatIconModule,
    SharedModule,
    RouterModule.forChild(authenticationRoutes),
    AngularFireAuthModule,
    AngularFireDatabaseModule
  ],
  providers: [EcommerceDashboardService, EcommerceDashboardResolver, DatePipe],
  exports: [
    TourOverlayComponent
  ]
})
export class AuthenticationModule {}

export { authenticationRoutes as routes };
